import { IsNotEmpty, IsOptional, IsString, IsUUID, Max, Min } from "class-validator";
import { EventDto, InterestDto } from ".";

export class EventToFitnessTypeDto {
	public id: string;
	public eventId: string;
	public fitnessTypeId: string;
	public masteryLevel?: number;
	public createdAt: Date;
	public updatedAt: Date;

	public event?: EventDto;
	public interest?: InterestDto;
}

export class UpdateEventToFitnessTypeDto {
	@IsOptional()
	@IsNotEmpty()
	@IsUUID()
	public id: string;

	@IsNotEmpty({ message: 'Fitness Type should not be empty' })
	@IsString()
	@IsUUID()
	public fitnessTypeId: string;

	@IsOptional()
	@Min(0)
	@Max(3)
	public masteryLevel?: number;

	@IsOptional()
	public delete?: boolean;

	@IsOptional()
	public eventId: string;

	public createdAt: Date;
	public updatedAt: Date;
}

export class ShortFitnessTypeDto {
	public fitnessTypeId: string;
	public masteryLevel?: number;
}
